import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { TrailerPlayer, getYouTubeId } from './TrailerPlayer';

const TrailerModal = ({ trailerUrl, onClose, title }) => {
  useEffect(() => {
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
    
    // Handle escape key
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    
    return () => {
      document.body.style.overflow = 'unset';
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  if (!getYouTubeId(trailerUrl)) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm p-4"
      onClick={(e) => { e.stopPropagation(); onClose(); }}
      data-testid="trailer-modal"
    >
      <div 
        className="relative w-full max-w-5xl bg-black rounded-2xl overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-end p-2 border-b border-white/10">
        <button
          onClick={onClose}
          data-testid="close-trailer-modal"
          aria-label="Close trailer"
          className="p-2 bg-white/10 hover:bg-white/20 rounded-full transition-colors"
        >
          <X className="w-6 h-6 text-white" />
        </button>
        </div>
        <TrailerPlayer trailerUrl={trailerUrl} title={title} testId="trailer-modal-iframe" />
      </div>
    </div>
  );
};

export default TrailerModal;
